// TODO - refatorar para usar chave de distincão, quando implementar numero de tentativas de login
export const INVALID_PASSWORD = 'INVALID_PASSWORD'
export const INVALID_EMAIL = 'INVALID_EMAIL'
export const UNKNOWN = 'UNKNOWN'
export const INVALID_SESSION = 'INVALID_SESSION'

export const hasError = (errors, key) => {
  errors = errorsFromExeption(errors)
  return errors?.some(err => err.key === key)
}

export const messageError = (error, key) => {
  const errors = errorsFromExeption(error)

  if (typeof error == 'object') return error?.message

  const errorByKey = errors?.find(err => err.key === key)
  return errorByKey?.message
}

const errorsFromExeption = error => {
  if (error?.graphQLErrors) return error?.graphQLErrors
  if (Array.isArray(error)) return error

  return []
}
